import { cn } from "@project/ui";
import { useI18n } from "@apps/dashboard/contexts/I18nContext";
import { BrandMark } from "@apps/dashboard/components/brand/BrandMark";

/**
 * Variación horizontal: isotipo + nombre (cabeceras / sidebar).
 */
export function BrandWordmark({
  className,
  markClassName,
  textClassName,
}: {
  className?: string;
  markClassName?: string;
  textClassName?: string;
}): JSX.Element {
  const { t } = useI18n();
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <BrandMark className={cn("size-9", markClassName)} />
      <span className={cn("font-headline font-black tracking-tight text-primary", textClassName)}>
        {t("dashboardUi.auth.appName")}
      </span>
    </div>
  );
}
